import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';

import { Response, FinancialInquiry, FinancialInquirySearchRequest, PagedResponse, FinancialInquiryRequest } from '@core/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialInquiryService {

  constructor(private http: HttpClient) { }

  search(request: FinancialInquirySearchRequest): Observable<PagedResponse<FinancialInquiry>> {
    return this.http.post<PagedResponse<FinancialInquiry>>(environment.apiUrl + '/api/FinancialInquiry/Search', request);
  }

  get(uuid: string): Observable<Response<FinancialInquiry>> {
    const headers = new HttpHeaders({ 'content-type': 'application/json' });
    return this.http.post<Response<FinancialInquiry>>(environment.apiUrl + '/api/FinancialInquiry/Get', JSON.stringify(uuid), { headers });
  }

  insert(request: FinancialInquiryRequest): Observable<Response<FinancialInquiry>> {
    return this.http.post<Response<FinancialInquiry>>(environment.apiUrl + '/api/FinancialInquiry/Insert', request);
  }

  update(request: FinancialInquiryRequest): Observable<Response<FinancialInquiry>> {
    return this.http.post<Response<FinancialInquiry>>(environment.apiUrl + '/api/FinancialInquiry/Update', request);
  }
}
